var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#703FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.76 36.575C38.4404 36.575 36.56 38.4554 36.56 40.775C36.56 43.0946 38.4404 44.975 40.76 44.975C43.0796 44.975 44.96 43.0946 44.96 40.775C44.964 39.6599 44.5228 38.5893 43.7343 37.8007C42.9457 37.0122 41.8751 36.571 40.76 36.575Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.535 26H35C30.0294 26 26 30.0294 26 35V46.535C26 51.5056 30.0294 55.535 35 55.535H46.535C51.5056 55.535 55.535 51.5056 55.535 46.535V35C55.535 30.0294 51.5056 26 46.535 26ZM40.76 47.21C37.2095 47.2018 34.3332 44.3255 34.325 40.775C34.3189 38.1635 35.8882 35.806 38.2998 34.8039C40.7113 33.8017 43.4892 34.3526 45.3358 36.1992C47.1824 38.0458 47.7333 40.8237 46.7311 43.2352C45.729 45.6468 43.3715 47.2161 40.76 47.21ZM46.3624 33.3676C46.6193 33.9799 47.221 34.3761 47.885 34.37C48.7797 34.37 49.505 33.6447 49.505 32.75C49.5111 32.086 49.115 31.4843 48.5026 31.2274C47.8903 30.9705 47.1835 31.1094 46.7139 31.5789C46.2444 32.0485 46.1055 32.7553 46.3624 33.3676Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.8124d91dd9f4e3c8bcc5bb994dae9350.svg";
export { ForwardRef as ReactComponent };